import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_TEMPLATE } from '../components/biggapon/templates';

/**
 * Holds the poster style the *viewer* picks in the advertisement-poster editor
 * (BiggaponModal). It overrides every poster (editor + job detail/download) so all
 * advertisements share one look, and persists to localStorage so the choice sticks
 * across visits.
 */
export const useBiggaponStyleStore = create(
    persist(
        (set) => ({
            styleId: DEFAULT_TEMPLATE,
            setStyleId: (styleId) => set({ styleId }),
        }),
        { name: 'biggapon-style' }
    )
);
